import axios from "axios";
import Cookies from "universal-cookie";

const cookies = new Cookies();

export const getCourseTypeApi = async (url:string) => {
    const token = cookies.get('authToken');
    try {
        const response = await axios.get(
            `${url}/CourseType/GetAllCourseType`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};


export const addCourseTypeApi = async (
    parentId: string | null,
    name: string,
    durationType: string | null,
    fees: number | null,
    availability: string | null,
    other: boolean,
    timings: string[] | null,
    url: string
) => {
    const token = cookies.get('authToken');
    try {
        const payload: Record<string, any> = {
            name,
            durationType,
            fees,
            availability,
            other
        };

        if (parentId) {
            payload.parentId = parentId;
        }
        const response = await axios.post(
            `${url}/CourseType/Create`,
            {
                name,
                durationType,
                fees,
                availability,
                other,
                timings
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        return response.data;
    } catch (error) {
        throw error;
    }
};

export const updateCourseTypeApi = async (
    Id: string,
    parentId: string | null,
    name: string,
    durationType: string | null,
    fees: number | null,
    availability: string | null,   
    other: boolean,
    timings: {
        id: string | null;
        time: string;
    }[] | null,
    availabilitysToDelete: string[] | null,
    url: string
) => {
    const token = cookies.get('authToken');
    try {
        const payload: Record<string, any> = {
            Id,
            name,
            durationType,
            fees,
            availability,
            other,
            timings,
            availabilitysToDelete
        };
        if (parentId) {
            payload.parentId = parentId;
        }
        const response = await axios.post(
            `${url}/CourseType/update`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error('API Error:', error);
        throw error;
    }
};

export const deleteCourseTypeApi = async (id: string, url: string) => {
    const token = cookies.get('authToken');

    try {

        const response = await axios.request({
            method: "DELETE",
            url: `${url}/CourseType/Delete`,
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
            data: {
                id,
            },
        });
        return response.data;

    } catch (error) {
        console.error(error)
        throw error;
    }
}
